import { useMemo, useState } from 'react';

import { VirtualCategory } from '@api/catalog';

import { Chip } from '@components/uiKit/Chip';

import { scale } from '@scripts/gds';
import { useMedia } from '@scripts/hooks';
import { themeColor } from '@scripts/themes/cssVars';

import ArrowRightIcon from '@icons/24/right-chevrone-arrow.svg';

import { getSorted } from '../helper';

const VirtualCategories = ({ virtual_categories }: { virtual_categories: VirtualCategory[] }) => {
    const { xs, sm } = useMedia();

    const categories = useMemo(() => getSorted(virtual_categories) || [], [virtual_categories]);

    const [isHidden, setIsHidden] = useState(true);
    const showDesktopToggle = categories.length > 10 && isHidden;

    return (
        <>
            <div
                css={{
                    color: themeColor.textBlack,
                    marginBottom: scale(5, true),
                    fontSize: '24px',
                    fontWeight: 500,
                    lineHeight: '120%',
                    letterSpacing: 0,
                }}
            >
                Часто ищут
            </div>
            <div
                css={{
                    position: 'relative',
                    width: '100%',
                }}
            >
                <div
                    css={{
                        overflow: isHidden ? 'hidden' : 'visible',
                        display: 'flex',
                        flexWrap: isHidden ? 'nowrap' : 'wrap',
                        columnGap: '12px',
                        rowGap: isHidden ? 0 : '12px',
                        marginRight: showDesktopToggle ? 154 : 0,
                        [xs]: {
                            marginRight: 0,
                            ...(isHidden
                                ? {
                                      overflowX: 'auto',
                                      flexWrap: 'nowrap',
                                      scrollbarWidth: 'none',
                                      msOverflowStyle: 'none',
                                      '&::-webkit-scrollbar': {
                                          display: 'none',
                                      },
                                  }
                                : {
                                      overflowX: 'visible',
                                      flexWrap: 'wrap',
                                  }),
                        },
                    }}
                >
                    {categories.map(item => (
                        <Chip
                            key={item.id}
                            href={`/catalog/collections/${item.code}`}
                            variant="outline"
                            size="xs"
                            style={{ maxWidth: '100%' }}
                            data-testid={`button-${item.code}`}
                        >
                            {item.name}
                        </Chip>
                    ))}
                </div>
                {showDesktopToggle && (
                    <div
                        css={{
                            display: 'flex',
                            position: 'absolute',
                            right: 0,
                            top: 0,
                            bottom: 0,
                            boxSizing: 'border-box',
                            width: 154,
                            paddingLeft: 40,
                            alignItems: 'center',
                            backgroundColor: themeColor.white,
                            [xs]: { display: 'none' },
                        }}
                    >
                        <button
                            type="button"
                            data-testid="button-categories"
                            aria-expanded={false}
                            onClick={() => setIsHidden(prev => !prev)}
                            css={{
                                minWidth: 'fit-content',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <div
                                css={{
                                    color: themeColor.green,
                                    ':hover': { color: themeColor.greenHover },
                                }}
                            >
                                Показать все
                            </div>
                            <ArrowRightIcon css={{ color: themeColor.textMiddle }} />
                        </button>
                    </div>
                )}
            </div>
            <button
                type="button"
                data-testid="button-categories"
                aria-expanded={!isHidden}
                onClick={() => setIsHidden(prev => !prev)}
                css={{
                    marginTop: '20px',
                    minWidth: 'fit-content',
                    cursor: 'pointer',
                    display: !isHidden ? 'flex' : 'none',
                    alignItems: 'center',
                    [sm]: {
                        display: 'flex',
                    },
                }}
            >
                <div
                    css={{
                        color: themeColor.green,
                        ':hover': { color: themeColor.greenHover },
                    }}
                >
                    {isHidden ? 'Показать все' : 'Свернуть все запросы'}
                </div>
                <ArrowRightIcon css={{ color: themeColor.textMiddle }} />
            </button>
        </>
    );
};

export default VirtualCategories;
